import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  organization: {
    display: 'block',
  },
}));

export default useStyles;
